import { useRef, useEffect, useState } from "react";

function isVirtualKeyboardVisible() {
  if (!window.visualViewport) return false;
  // Compare visual viewport to layout viewport height
  // If they differ significantly, keyboard is probably up
  return (window.innerHeight - window.visualViewport.height) > 150;
}

export function useContainerSize() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState({ sWidth: 0, sHeight: 0 });

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    setSize({ sWidth: el.clientWidth, sHeight: el.clientHeight });

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        // Skip resize if it's just the virtual keyboard appearing
        if (isVirtualKeyboardVisible()) {
          return;
        }
        const { width, height } = entry.contentRect;
        setSize({ sWidth: width, sHeight: height });
      }
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return { containerRef, ...size };
}
